var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.BUSINESS_REPORT_SALE_ROUTE_LIST },
      }),
      _c(
        "el-form",
        { ref: "queryParams" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("BjDateTimerangePicker", {
                    attrs: {
                      placeholder: _vm.$t("BusinessReportSaleGoods.orderTime"),
                    },
                    model: {
                      value: _vm.queryParamsTime,
                      callback: function ($$v) {
                        _vm.queryParamsTime = $$v
                      },
                      expression: "queryParamsTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      placeholder: _vm.$t("BusinessReportSaleGoods.channel"),
                      "lov-code": "SCHL.CHANNEL_TYPE",
                    },
                    model: {
                      value: _vm.queryParams.channel,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "channel", $$v)
                      },
                      expression: "queryParams.channel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "text-right" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", plain: "" },
                            on: { click: _vm.onSeach },
                          },
                          [_vm._v(_vm._s(_vm.$t("searchText")))]
                        ),
                        _c(
                          "el-button",
                          { attrs: { plain: "" }, on: { click: _vm.onReset } },
                          [_vm._v(_vm._s(_vm.$t("resetText")))]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vxe-table",
        {
          attrs: {
            align: _vm.allAlign,
            data: _vm.tableData,
            stripe: "",
            border: "",
            "empty-text": _vm.$t("table.emptyText"),
            "max-height": "600",
          },
        },
        [
          _vm._l(_vm.labelList, function (col, index) {
            return [
              _c("vxe-column", {
                key: index,
                attrs: { width: col.width, "show-overflow": "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [_vm._v(" " + _vm._s(col.label) + " ")]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          false
                            ? void 0
                            : [
                                "saleAmount",
                                "balanceSaleAmount",
                                "reverseAmount",
                                "reverseAmount",
                              ].includes(col.prop)
                            ? [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$number2money(row[col.prop])) +
                                    " "
                                ),
                              ]
                            : col.prop === "status"
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: row.status ? "success" : "info",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        _vm.STATUS_ENABLED_NUM.bjGet(
                                          row[col.prop]
                                        )
                                      )
                                    ) + " "
                                  ),
                                ]
                              )
                            : _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("timeFilters")(
                                      row[col.prop],
                                      row[col.prop]
                                    )
                                  )
                                ),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }